import domReady from '@wordpress/dom-ready';

domReady( () => {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  /* Block scripts */
  if ( document.querySelector('.aging-with-purpose-logo') ) {
    document.querySelectorAll('.aging-with-purpose-logo').forEach(block => {
      gsap.set(block, {
        opacity: 0,
        y: 32
      });

      ScrollTrigger.create({
        trigger: block,
        start: 'top 80%',
        onEnter: () => {
          gsap.to(block, {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: 'power3.inOut'
          });
        }
      });
    });
  }
});